export const STANDARD_MATERIAL_WIDTH_MIN = 160
export const STANDARD_MATERIAL_WIDTH_MAX = 430
export const STANDARD_MATERIAL_WIDTH_STEP = 5
export const MATERIAL_WIDTH_TOLERANCE_MM = 10

export function isStandardMaterialWidth(width: number): boolean {
    const numericWidth = Number(width)

    if (Number.isNaN(numericWidth)) {
        return false
    }

    return (
        numericWidth >= STANDARD_MATERIAL_WIDTH_MIN &&
        numericWidth <= STANDARD_MATERIAL_WIDTH_MAX &&
        numericWidth % STANDARD_MATERIAL_WIDTH_STEP === 0
    )
}

export function getMinSelectableMaterialWidth(orientirWidth?: number): number | undefined {
    if (orientirWidth == null) {
        return undefined
    }

    const numericWidth = Number(orientirWidth)

    if (Number.isNaN(numericWidth)) {
        return undefined
    }

    return Math.min(
        STANDARD_MATERIAL_WIDTH_MAX,
        Math.max(STANDARD_MATERIAL_WIDTH_MIN, numericWidth - MATERIAL_WIDTH_TOLERANCE_MM)
    )
}
